import { AbstractDestroyable } from '@deqo/foundation';
import { debounce } from '../../../CodesThatsGottaGoSomewhereElse';
import { component, Component, ObjectManager, property } from '../../../concepts/objects';
import { JsonType } from '../../../concepts/objects/JsonType';

class BoardSettingGroupObserver extends AbstractDestroyable {

    constructor(
        private group: string,
        private callback: (values: Record<string, any>) => void) {
        super();
    }

    public start(objects: ObjectManager): this {

        const readLatest = () => Array
            .from(objects.getAll(BoardSetting))
            .filter(x => x.alive && x.group === this.group)
            .sort((a, b) => b.id.localeCompare(a.id))
            .map(x => ({ [x.name]: x.value }))
            .reduce((acc, x) => Object.assign(acc, x), {});

        const fire = debounce(() => this.callback(readLatest()));

        this.burden(
            objects.on('BoardSetting', 'allocated', fire),
            objects.on('BoardSetting', 'affected', fire),
            objects.on('BoardSetting', 'released', fire),
        );

        fire();
        return this;
    }

}

const boardSettingDef = {
    name: 'BoardSetting',
};

@component(boardSettingDef)
export class BoardSetting extends Component {

    public static readGroup(group: string, objects: ObjectManager) {
        return Array
            .from(objects.getAll(BoardSetting))
            .filter(x => x.group === group)
            .sort((a, b) => b.id.localeCompare(a.id))
            .map(x => ({ [x.name]: x.value }))
            .reduce((acc, x) => Object.assign(acc, x), {});
    }

    public static watchGroup(group: string, callback: (values: Record<string, any>) => void) {
        return new BoardSettingGroupObserver(group, callback);
    }

    @property({ type: 'string' })
    public group: string;

    @property({ type: 'string' })
    public name: string;

    @property({ type: JsonType })
    public value: any;

}
